module.exports = __webpack_public_path__ + "dash_20_app_assets/img/ReviewShare.42eb536d.png";